export const audioPauseIcon = `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M14 19V5H18V19H14ZM6 19V5H10V19H6Z" fill="var(--zbp-svg-primary-color, black)"/>
</svg>
`;
